import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import MaterialGrid from "../../../../__snowpack__/pkg/@mui/material/Grid.js";
import MaterialTypography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React from "react";
import Form from "../../atoms/form/form.component.js";
import RadioList from "../radio-list/radio-list.component.js";
import SearchBar from "../search-bar/search-bar.components.js";
import {UnitListInnerContainerSearch} from "./unit-list.styles.js";
function UnitList({
  data,
  title,
  onSearch,
  onChange,
  reset
}) {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true
  }, /* @__PURE__ */ React.createElement(MaterialTypography, {
    variant: "h5"
  }, t(title))), /* @__PURE__ */ React.createElement(MaterialGrid, {
    item: true
  }, /* @__PURE__ */ React.createElement(UnitListInnerContainerSearch, null, /* @__PURE__ */ React.createElement(SearchBar, {
    label: t("units.search", {
      type: "units"
    }),
    onSearch
  })), /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(RadioList, {
    items: data,
    onChange,
    reset
  }))));
}
export default /* @__PURE__ */ React.memo(UnitList);
